import React from "react";
import ScrollAnimation from "react-animate-on-scroll";

export default function JalurPenerimaan({ data }) {
  return (
    <section
      className="bg-cover bg-no-repeat w-full -md:pt-20 pb-72 md:bg-jalur1 -md:bg-jalur2"
      style={{
        minHeight: "1000px",
        backgroundPosition: "center top",
      }}
    >
      <div className="container md:pr-20 md:pt-56 flex justify-end items-center">
        <div className="flex flex-col -md:pt-40 md:justify-end">
          <ScrollAnimation animateOnce={true} animateIn="fadeInRight">
            <div className="flex items-center space-x-4">
              <div className="bg-white md:w-110 md:h-4 -md:w-12 -md:h-1"></div>
              <h1 className="md:text-6xl -md:text-lg text-white italic font-black text-right">
                {data.title}
              </h1>
            </div>
            <h1 className="md:text-6xl -md:text-lg text-yellow italic font-black text-right">
              {data.subtitle}
            </h1>
          </ScrollAnimation>
        </div>
      </div>

      {data.items.map((item, i) => (
        <div
          key={i}
          className={`flex -md:flex-col -md:container relative justify-center items-center md:mt-20 -md:mt-10 ${
            (i + 1) % 2 === 0 && "flex-row-reverse"
          }`}
        >
          <div
            className={`md:w-1/2 -md:container flex flex-col ${
              (i + 1) % 2 === 0 ? "md:pr-28" : "md:pl-28"
            }`}
          >
            <ScrollAnimation
              animateOnce={true}
              animateIn={`${(i + 1) % 2 === 0 ? "fadeInRight" : "fadeInLeft"}`}
            >
              <h2
                className="-ml-6 md:w-10/12 md:text-4xl italic -md:text-xl text-yellow font-medium"
                dangerouslySetInnerHTML={{
                  __html: `${item.title}`,
                }}
              />
              <ul className="text-2xl -md:text-xs text-white mt-5 list-outside list-disc">
                {item.syarat.map((syarat, i) => (
                  <li key={i}>{syarat}</li>
                ))}
              </ul>
            </ScrollAnimation>
          </div>
          <div className="md:w-1/2 -md:container -md:mt-10 relative md:h-125">
            <ScrollAnimation
              animateOnce={true}
              animateIn={`${(i + 1) % 2 === 0 ? "fadeInLeft" : "fadeInRight"}`}
            >
              <img
                className={`${imageClass[i]} w-auto -md:hidden`}
                src={item.image}
                alt="Asset"
              />
              <img
                className={`${imageClass[i]} w-auto -md:w-10/12 -md:mx-auto md:hidden`}
                src={item.image2 ? item.image2 : item.image}
                alt="Asset"
              />
            </ScrollAnimation>
          </div>
        </div>
      ))}
    </section>
  );
}

export const imageClass = [
  "md:w-10/12 md:mr-10",
  "md:w-9/12 md:ml-20",
  "md:w-9/12 md:ml-10",
  "md:w-9/12 md:ml-20",
  "md:w-10/12 ml-auto",
  "md:w-10/12 md:ml-20",
  "md:w-8/12 md:ml-10",
];
